'use client';

import { Button } from '@shared/components/shadcn';
import { Verified } from '@shared/icons/system';
import { useTranslations } from 'next-intl';
import { useMultistepForm } from '../../../../../../form-controls/MultistepForm/hooks/useMultistepForm';

type SuccessStepProps = {
  onContinue?: () => void;
};

const SuccessStep = ({ onContinue }: SuccessStepProps) => {
  const t = useTranslations('my_account');
  const showDescription = t.has('pages.edit_email.success_step.description');
  const { goToNextStep } = useMultistepForm();

  const handleContinue = () => {
    if (onContinue) {
      onContinue();
      return;
    }
    void goToNextStep();
  };

  return (
    <div className="flex flex-col h-full" data-testid="success-step">
      <div className="md:mt-6">
        <Verified size="extra-extra-large" className="mb-5" data-testid="verified-icon" />
        <h4 className={showDescription ? 'mb-2 text-left' : 'mb-8'} data-testid="success-title">
          {t('pages.edit_email.success_step.title')}
        </h4>
        {showDescription ? (
          <p className="paragraph-explanatory mb-8 text-left" data-testid="success-description">
            {t('pages.edit_email.success_step.description')}
          </p>
        ) : null}
      </div>
      <div className="text-center mt-auto md:mt-8" data-track-container="Actions">
        <Button className="w-full" onClick={handleContinue} data-testid="success-continue-button" data-track-name="Done">
          {t('pages.edit_email.success_step.continue', { default: 'Continue' })}
        </Button>
      </div>
    </div>
  );
};

export { SuccessStep };
